// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cropper[data-v-479956a5] {\n    /*border: solid 1px #EEE;*/\n    height: 350px;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
